import React, { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import GenericTable from "../GenericTable/GenericTable";
import { ClusterObjTable, ClusterTable } from "../../store/ducks/cluster/types";

const perf: ClusterObjTable[] = [];
const col: GridColDef[] = [];

const ClusterTableComponent = (props: any) => {
  const [txtBusca, setTxtBusca] = useState("");
  const [columns, setColumns] = useState(col);
  const [listClusters, setListClusters] = useState(perf);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [numberElements, setNumberElements] = useState(0);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    generateColumnsTable();
  }, []);

  useEffect(() => {
    if (props.data) {
      tranformObjectTable(props.data);
    }
  }, [props.data]);

  const generateColumnsTable = () => {
    const _columns: GridColDef[] = [
      { field: "nmCluster", headerName: "Nome", width: 300 },
      { field: "dsCluster", headerName: "Descrição", width: 400 },
    ];

    setColumns(_columns);
  };

  const tranformObjectTable = (obj: ClusterTable) => {
    setSize(obj.size);
    setPage(obj.number);
    setTotalElements(obj.totalElements);
    setTotalPages(obj.totalPages);
    setNumberElements(obj.numberOfElements);
    setOffset(obj.pageable.offset);

    let list: ClusterObjTable[] = obj.content.map((content: any) => {
      const item = [content.idCluster, content.nmCluster, content.dsCluster];
      return {
        id: item[0],
        idCluster: item[0],
        nmCluster: item[1],
        dsCluster: item[2],
      };
    });

    setListClusters(list);
  };

  const onPageChange = (pageIdx: any) => {
    props.body.pagina = pageIdx - 1;
    setPage(pageIdx - 1);
    props.onChange(props.body);
  };

  const onSizeChange = (_size: any) => {
    props.body.tamanho = _size;
    setSize(_size);
    props.onChange(props.body);
  };

  const onChangeBusca = (txt: string) => {
    props.body.txtBusca = txt;
    setTxtBusca(txt);
    if (txt.length >= 3) {
      props.onChange(props.body);
    } else {
      props.body.txtBusca = "";
      props.onChange(props.body);
    }
  };

  const onSortChange = (sort: any) => {
    if (sort != undefined) {
      let colunaSort =
        sort.field && sort.field == "nmCluster"
          ? "nmCluster"
          : sort.field == "dsCluster"
          ? "dsCluster"
          : "nmCluster";

      props.body.coluna = colunaSort;
      props.body.ordem = sort.sort.toUpperCase();
    } else {
      props.body.coluna = "nmCluster";
      props.body.ordem = "ASC";
    }
    props.onChange(props.body);
  };

  return (
    <GenericTable
      loading={props.loading}
      titleTable="Clusters Cadastrados"
      rows={listClusters}
      columns={columns}
      page={page}
      totalPages={totalPages}
      onPageChange={onPageChange}
      offset={offset}
      numberElements={numberElements}
      totalElements={totalElements}
      size={size}
      sizeChange={onSizeChange}
      txtBusca={txtBusca}
      onChangePesquisa={onChangeBusca}
      selection={props.selection}
      idSelectionChange={(arr: any) => props.idSelectionChange(arr)}
      sortChange={onSortChange}
    />
  );
};

export default ClusterTableComponent;
